import Vue from 'vue'
import VueRouter from 'vue-router'
import VueGtag from 'vue-gtag'
import env from 'env'

import UserList from './pages/UserList.vue'
//import UserEdit from './pages/UserEdit.vue'
//import ItemList from './pages/ItemList.vue'
//import AnswerList from './pages/AnswerList.vue'
//import IDetail from './pages/IDetail.vue'
//import IList from './pages/IList.vue'
//import UDetail from './pages/UDetail.vue'
import Landing from './pages/Landing.vue'
import Me from './pages/Me.vue'
//import MeFavorites from './pages/MeFavorites.vue'
import MeConnect from './pages/MeConnect.vue'
import MeInventoryList from './pages/MeInventoryList.vue'
import MeStoreList from './pages/MeStoreList.vue'
import MeListingList from './pages/MeListingList.vue'
import MeMarunageList from './pages/MeMarunageList.vue'
import MeItemList from './pages/MeItemList.vue'
import MeOrderList from './pages/MeOrderList.vue'
import MeSettings from './pages/MeSettings.vue'
import MeShippingList from './pages/MeShippingList.vue'
import MeShippingEcmsOrderList from './pages/MeShippingEcmsOrderList.vue'
import MeInsuranceList from './pages/MeInsuranceList.vue'
import MeFile from './pages/MeFile.vue'
//import CustomerList from './pages/CustomerList.vue'
//import MessageList from './pages/MessageList.vue'
//import MessageDetail from './pages/MessageDetail.vue'
//import CustomerDetail from './pages/CustomerDetail.vue'
//import CustomerList from './pages/CustomerList.vue'
//import CustomerDetail from './pages/CustomerDetail.vue'
import Setting from './pages/Setting.vue'
import Login from './pages/Login.vue'
import UserApproval from './pages/UserApproval.vue'
import ShippingAddress from './pages/ShippingAddress.vue'
import ShippingBoxes from './pages/ShippingBoxes.vue'
import ShippingItems from './pages/ShippingItems.vue'
import ShippingHscodes from './pages/ShippingHscodes.vue'
import ListingHtml from './pages/ListingHtml.vue'
//import Agreement from './pages/Agreement.vue'
//import Policy from './pages/Policy.vue'
import SystemError from './pages/errors/System.vue'


import store from './store'

// https://stackoverflow.com/questions/57837758/navigationduplicated-navigating-to-current-location-search-is-not-allowed
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'landing',
        component: Landing,
        props: true,
        meta: {
            title: '',
            auth_level: '000',
            navbar: true,
        },
    },
    {
        path: '/me',
        name: 'me',
        component: Me,
        props: true,
        meta: {
            title: 'マイページ',
            auth_level: '001',
            navbar: true,
        },
    },
    {
        path: '/me/connect/:provider',
        name: 'me.connect',
        component: MeConnect,
        props: true,
        meta: {
            title: '外部連携設定',
            auth_level: '001',
            navbar: true,
        },
    },
    {
        path: '/me/listings',
        name: 'me.listings',
        component: MeListingList,
        props: true,
        meta: {
            title: '出品一覧',
            auth_level: '001',
            navbar: true,
            fullwidth: true,
        },
    },
    {
        path: '/me/items',
        name: 'me.items',
        component: MeItemList,
        props: true,
        meta: {
            title: '登録済み在庫一覧',
            auth_level: '001',
            navbar: true,
        },
    },
    {
        path: '/me/orders',
        name: 'me.orders',
        component: MeOrderList,
        props: true,
        meta: {
            title: '在庫連携eBay注文一覧',
            auth_level: '001',
            navbar: true,
            fullwidth: true,
        },
    },
    {
        path: '/me/marunage',
        name: 'me.marunage',
        component: MeMarunageList,
        props: true,
        meta: {
            title: '登録済みまるなげ一覧',
            auth_level: '001',
            navbar: true,
            fullwidth: true,
        },
    },
    {
        path: '/me/shippings',
        name: 'me.shippings',
        component: MeShippingList,
        props: true,
        meta: {
            title: '登録済み配送一覧(DHL)',
            auth_level: '001',
            navbar: true,
            fullwidth: true,
        },
    },
    {
        path: '/me/shippings/ecms_order',
        name: 'me.shippings.ecms_order',
        component: MeShippingEcmsOrderList,
        props: true,
        meta: {
            title: '登録済み配送一覧(ECMS)',
            auth_level: '001',
            navbar: true,
            fullwidth: true,
        },
    },
    {
        path: '/me/insurances/:q?',
        name: 'me.insurances',
        component: MeInsuranceList,
        props: true,
        meta: {
            title: '登録済み保険一覧',
            auth_level: '001',
            navbar: true,
            fullwidth: true,
        },
    },
    {
        path: '/me/file',
        name: 'me.file',
        component: MeFile,
        props: true,
        meta: {
            title: 'ファイルDL',
            auth_level: '100',
            navbar: true,
            fullwidth: true,
        },
    },
    {
        path: '/settings/app',
        name: 'settings.app',
        component: Setting,
        props: true,
        meta: {
            title: 'システム全体設定',
            auth_level: '300',
            navbar: true,
        },
    },
    {
        path: '/settings/users',
        name: 'settings.users',
        component: UserList,
        props: true,
        meta: {
            title: '登録ユーザー一覧',
            auth_level: '200',
            navbar: true,
            fullwidth: true,
        },
    },
    {
        path: '/settings/users/:uuid/approval',
        name: 'settings.users.approval',
        component: UserApproval,
        props: true,
        meta: {
            title: '承認確認',
            auth_level: '300',
            navbar: true,
        },
    },
    {
        path: '/settings/shippings/addresses',
        name: 'settings.shippings.addresses',
        component: ShippingAddress,
        props: true,
        meta: {
            title: '登録住所一覧',
            auth_level: '100',
            navbar: true,
        },
    },
    {
        path: '/settings/shippings/boxes',
        name: 'settings.shippings.boxes',
        component: ShippingBoxes,
        props: true,
        meta: {
            title: '登録梱包一覧',
            auth_level: '100',
            navbar: true,
        },
    },
    {
        path: '/settings/shippings/items',
        name: 'settings.shippings.items',
        component: ShippingItems,
        props: true,
        meta: {
            title: '登録内容物一覧',
            auth_level: '100',
            navbar: true,
        },
    },
    {
        path: '/settings/shippings/hscodes',
        name: 'settings.shippings.hscodes',
        component: ShippingHscodes,
        props: true,
        meta: {
            title: '登録HSコード一覧',
            auth_level: '100',
            navbar: true,
        },
    },
    {
        path: '/settings/listings/html',
        name: 'settings.listings.html',
        component: ListingHtml,
        props: true,
        meta: {
            title: '商品説明HTML一覧',
            auth_level: '100',
            navbar: true,
        },
    },
    {
        path: '/500',
        component: SystemError
    }
]

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve({ x: 0, y: savedPosition.y })
                }, 500)
            })
        } else {
            return { x: 0, y: 0 }
        }
    }
})

router.afterEach(async (to, from) => {
    await store.dispatch('app/data')
    store.dispatch('auth/me').then(() => {
//            document.title = store.getters.trans.pages[to.meta.title]
    })

    try {
        const url = new URL(location.href)
        if (url.pathname.match(/^\/public\/www/)) {
            location.href = location.href.replace(/\/public\/www/, '')
        }
    } catch (e) {
        console.log(e)
    }
})

Vue.use(VueGtag, {
    config: { id: env.GOOGLE_ANALYTICS, },
}, router);

export default router

